module.exports = __webpack_public_path__ + "static/media/logo.c54a605c.png";